import AsyncFlow from '../asyncFlow';

export default AsyncFlow({
    store: 'set-old-serial-number',
    initialState: {
        isInserted: '',
        statusAction: 'READY',
    },
    actions: ['SET_SN_OLD'],
}).extend({
    reducer: (state, action, { types }) => {
        switch (action.type) {
            case types.SET_SN_OLD_SUCCESS:
                return {
                    ...state,
                    isInserted: action.payload.isInserted
                };
            default:
                return state;
        }
    },
    creators: ({ types }) => ({
        setSerialNumberOldRequest: (pk, IDLicenza, new_sn_old, codiceUtente ) => ({
            type: types.SET_SN_OLD_REQUEST,
            payload: { pk, IDLicenza, new_sn_old, codiceUtente },
        }),
        setSerialNumberOldSuccess: ({ isInserted }) => ({
            type: types.SET_SN_OLD_SUCCESS,
            payload: { isInserted },
        }),
        setSerialNumberOldFailed: error => ({ type: types.SET_SN_OLD_FAILED, error: true, payload: { error } }),
    }),
});
